import { Injectable } from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { HttpAuth } from './http-auth.service';
import { Observable } from 'rxjs';
import { Gender } from '../models/gender';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

@Injectable()
export class GenderService {

  private eduLvlUrl: string = `${ environment.apiRoot }/gender/`;

  constructor(private http: HttpAuth) {}

  public _subject = new Subject<object>();
  public event = this._subject.asObservable();

  public publish (data: Gender) {
    this._subject.next(data);
  }

  createRequestHeaders(headers: Headers, userId?:string) {
    headers.set('Content-Type', 'application/json');
    headers.set('X-API-KEY', environment.apiKey);
    
  }

  public getGender(userId?: string): Observable<Gender> {
    let headers = new Headers();
    this.createRequestHeaders(headers);
    let options = {headers: headers};

    return this.http.get(this.eduLvlUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

   //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/gender.service.ts